import { storeProvider } from 'ReduxHelpers';
import { reactRouterProvider } from 'FrontRoyalRouter/reactRouterProvider';
import { routeTransitionActions } from './routeTransitionSlice';
import { type Destination, type Direction } from './RouteAnimation.types';

// See routing.md -> "Route Animations and Back Navigation"

export async function animatePathChange(destination: Destination, direction: Direction = 'forward'): Promise<void> {
    const store = storeProvider.store;

    if (!supportsAnimations() || !store) {
        reactRouterProvider.navigate(destination);
        return;
    }

    const transitionId = Date.now();
    store.dispatch(routeTransitionActions.startTransition({ destination, direction, transitionId, now: Date.now() }));
}

function supportsAnimations(): boolean {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return true;
    }

    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
